"use client"

import { useRef } from "react"
import clsx from "clsx"

import type { Nullish } from "~/@types/generics"
import { useGetSizeGuide } from "~/hooks/useGetSizeGuide"
import PanelFooter from "~/components/ui/Panels/PanelFooter"
import PanelHeader from "~/components/ui/Panels/PanelHeader"
import PanelContent from "~/components/ui/Panels/SizeGuide/components/PanelContent"
import type { TSizeGuideSlice } from "~/components/slices/SizeGuideSlice/types"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"
import { useInternalRedirects } from "~/providers/InternalRedirectsProvider/index.client"
import { Panel } from "~/managers/PanelManager"

import * as css from "./styles.css"

export type SizeGuidePanelProps = {
  productType?: string | null
  content?: Nullish<TSizeGuideSlice>
}

function SizeGuidePanel({ content, productType }: SizeGuidePanelProps) {
  const t = useTranslate()
  const panelRef = useRef<HTMLDivElement>(null)
  const [redirects] = useInternalRedirects()

  const { data } = useGetSizeGuide(productType ?? "", {
    enabled: !content,
    placeholderData: content,
  })

  return (
    <Panel className={clsx(css.wrapper)} zIndex={60} clickOutsideRef={panelRef}>
      <div className={clsx(css.SizeGuidePanel)} ref={panelRef}>
        <PanelHeader title={t("size_guide")} />
        <PanelContent className={clsx(css.content)} items={data} />
        {redirects?.sizeGuide && <PanelFooter className={clsx(css.footer)} />}
      </div>
    </Panel>
  )
}

export default SizeGuidePanel
